<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'
export default {
  name: 'UpLevelDayStat',
  props: {
    title: {
      Type: String,
      default: '通关率'
    },
    k: {
      Type: String,
      default: 'Rate'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '通关率'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '20%'
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(dateArr, data) {
      const time = []
      for (const i in dateArr) {
        time.push(dateStrTodate(dateArr[i].date))
      }
      const optionData = {}
      for (const i in data) {
        const val = data[i]
        for (const k in val) {
          if (optionData[k] === undefined) {
            optionData[k] = []
          }
          optionData[k].push(val[k][this.k])
        }
      }
      for (const i in optionData) {
        const levelText = '等级' + i
        this.option.legend.data.push(levelText)
        const tempOption = {
          name: levelText,
          data: optionData[i],
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }
        this.option.series.push(tempOption)
      }
      this.option.title.text = this.title
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
